$(function () {
  $('body').append(`
  <!-- 复制内容 -->
  <p id="copy-id" style="font-size:0px;">BLBSOFT</p>
  <p id="copy-mail-id" style="font-size:0px;">support@blbsoft.com</p>

  <!-- 复制提示 -->
  <div class="toast-container position-fixed top-0 start-50 translate-middle-x p-3">
    <div id="liveToast" class="toast text-bg-secondary" role="alert" aria-live="assertive" aria-atomic="true">
      <div class="toast-body">
        <div>
          <span id="copy-msg"></span>
        </div>
      </div>
    </div>
  </div>

  <!-- 关注窗口 -->
  <div class="modal fade" id="focusModal" tabindex="-1" aria-labelledby="focusModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h1 class="modal-title fs-5" id="focusModalLabel">关注</h1>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <div class="d-flex flex-column gap-3">
            <button id="douyin-btn" class="btn btn-danger" type="button" data-clipboard-target="#copy-id">
              抖音号<br />@BLBSOFT
            </button>
            <button id="weixin-btn" class="btn btn-success" type="button" data-clipboard-target="#copy-id">
              视频号<br />@BLBSOFT
            </button>
            <button id="mail-btn" class="btn btn-primary" type="button" data-clipboard-target="#copy-mail-id">
              邮件地址<br />support@blbsoft.com
            </button>
            <a href="mailto:support@blbsoft.com" class="btn btn-primary">
              使用默认邮件客户端发送邮件
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
  `)

  $('#focus-row').append(` 
  <a id="focus-btn" class="text-light text-dashed" href="#focusModal" data-bs-toggle="modal">
    <span
      class="d-flex gap-2 align-items-center justify-content-end animate__animated animate__headShake animate__infinite">
      <!-- <i class="bi bi-heart-fill align-self-center"></i> -->
      <span class="d-block align-self-center">关注</span>
    </span>
  </a>
  `)

  function showClipboardToast(msg) {
    // let toastLiveExample = document.getElementById('liveToast')
    // let toast = new bootstrap.Tooltip(toastLiveExample)
    // toast.show()
    $('#copy-msg').html(msg)
    $("#liveToast").addClass('show')

    setTimeout(()=>{
      $("#liveToast").removeClass('show')
    }, 3000)
  }


  let douyin_clipboard = new ClipboardJS('#douyin-btn');
  douyin_clipboard.on('success', function (e) {
    // console.info('Action:', e.action);
    // console.info('Text:', e.text);
    // console.info('Trigger:', e.trigger);

    e.clearSelection();

    // alert("抖音号已复制到剪贴板");
    // $("#douyin-msg").text("抖音号已复制到剪贴板");

    // setTimeout(() => {
    //   $("#douyin-msg").text("");
    // }, 3000);

    showClipboardToast("抖音号已复制到剪贴板")
  });

  let winxin_clipboard = new ClipboardJS('#weixin-btn');
  winxin_clipboard.on('success', function (e) {
    // console.info('Action:', e.action);
    // console.info('Text:', e.text);
    // console.info('Trigger:', e.trigger);

    e.clearSelection();

    // alert("视频号已复制到剪贴板");
    // $("#douyin-msg").text("视频号已复制到剪贴板");

    // setTimeout(() => {
    //   $("#douyin-msg").text("");
    // }, 3000);

    showClipboardToast("视频号已复制到剪贴板")
  });

  let mail_clipboard = new ClipboardJS('#mail-btn');
  mail_clipboard.on('success', function (e) {
    // console.info('Action:', e.action);
    // console.info('Text:', e.text);
    // console.info('Trigger:', e.trigger);

    e.clearSelection();

    // alert("视频号已复制到剪贴板");
    // $("#douyin-msg").text("邮件地址已复制到剪贴板");

    // setTimeout(() => {
    //   $("#douyin-msg").text("");
    // }, 3000);

    showClipboardToast("邮件地址已复制到剪贴板")
  });
})